import { render } from "./bet-start-stop-pop.vue?vue&type=template&id=01ccb532&ts=true"
import script from "./bet-start-stop-pop.vue?vue&type=script&lang=ts"
export * from "./bet-start-stop-pop.vue?vue&type=script&lang=ts"

import "./bet-start-stop-pop.vue?vue&type=style&index=0&id=01ccb532&lang=scss"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__